export default [
  {
    path: '/certification/:courseId',
    name: 'certification',
    meta: {
      title: '我的证书'
    },
    component: () => import(/* webpackChunkName: "certification" */'./views/index')
  }
]
